import React, { FC } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useStyles } from './map-placeholder.styles';

interface MapPlaceholderProps {
  loading?: boolean;
  error?: boolean;
  message?: string;
}

export const MapPlaceholder: FC<MapPlaceholderProps> = ({ loading, error, message }) => {
  const classes = useStyles();

  return (
    <div className={classes.placeholder}>
      {loading && (
        <>
          <CircularProgress />
          <Typography variant="body1" className={classes.message}>
            Loading map...
          </Typography>
        </>
      )}
      {error && (
        <>
          <svg
            className={classes.errorIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <Typography variant="body1" className={classes.message}>
            {message || 'Map unavailable'}
          </Typography>
        </>
      )}
    </div>
  );
};